//#region src/metas/capture.ts
const capturedMetas = /* @__PURE__ */ new WeakSet();
function markMetaCaptured(meta) {
	capturedMetas.add(meta);
	return meta;
}
function isMetaCaptured(meta) {
	return capturedMetas.has(meta);
}
/** Capture metadata, including with extension implementations predating capture listeners. */
function captureMetas(metas, callback) {
	if (metas.capture) return markMetaCaptured(metas.capture(callback));
	const meta = markMetaCaptured(metas.value);
	callback === null || callback === void 0 || callback();
	return meta;
}
//#endregion
export { captureMetas, isMetaCaptured, markMetaCaptured };

//# sourceMappingURL=capture.js.map